<div style="padding: 1em;">
    <div class="d-flex justify-content-between align-items-center mb-3">
        <h2 class="mb-0">Create application</h2>
    </div>
    <mat-dialog-content>
        <form [formGroup]="form">
            <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" (click)="submitApplication()">Submit</button>
        <button mat-button (click)="onCancel()">Cancel</button>
    </mat-dialog-actions>
</div>